import React from 'react';

import { cn } from '../cn';
import { LazyImg } from '../ImgLazyLoader';
import { Button } from '../Button/Button';
import { Tag } from '../Tag';
import { Typography } from '../Typography/Typography';

export type PhotoCardProps = React.PropsWithChildren<{
  image: string,
  title: string | JSX.Element,
  text: string,
  footerText?: string | JSX.Element;

  className?: string,
  imgClassName?: string;
  titleClassName?: string;
  textClassName?: string;
  aspectClassName?: string;
  footerTextClassName?: string;

  to?: string;
  onPress?: () => void;
  tags?: {text: string, status: 'success' | 'primary' | 'error' | 'warning'}[];
  tagsPosition?: 'above' | 'right';
}>;

export const PhotoCard = (props: PhotoCardProps): JSX.Element => {
  props = Object.assign({tagsPosition: 'above', aspectClassName: 'aspect-video', tags: []}, props);
  return (
    <Button
      unstyled to={props.to} onPress={props.onPress}
      className={cn(
        'p-1 flex flex-1 flex-col gap-5 border-b-thin border-b-surface-darker transition-all duration-500 pb-5 justify-between',
        props.className
      )}
    >
      <div className='flex flex-col gap-3'>
        <LazyImg src = {props.image} className={cn('object-cover transition-all duration-500', props.aspectClassName, props.imgClassName)}/>
        <div className='flex flex-col gap-1'>
          <div className='flex flex-row items-start gap-1'>
            {props.tagsPosition === 'above' ? props.tags?.map((tag, index) => (
              <Tag label = {tag.text} status = {tag.status} key={index}/>
            )) : ''}
          </div>
          <Typography heading expressive weight='bold' className={cn('flex gap-4 justify-between items-start w-full min-h-[64px] line-clamp-2', props.titleClassName)}>
            <div className='w-full'>{props.title}</div>
            {props.tagsPosition === 'right' ? props.tags?.map((tag, index) => (
              <Tag label = {tag.text} status = {tag.status} key={index}/>
            )) : ''}
          </Typography>
          <Typography className={cn('text-text-light line-clamp-2 pt-1', props.textClassName)}>{props.text}</Typography>
        </div>
      </div>
      {props.footerText && <Typography className={cn('text-text-lighter', props.footerTextClassName)} weight='medium' size='xs'>{props.footerText}</Typography>}
    </Button>
  );
};
